"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.didiOrderStatusFilter = didiOrderStatusFilter;
exports.didiPayStatusFilter = didiPayStatusFilter;
exports.orderRefundStatusFilter = orderRefundStatusFilter;
exports.orderStatusFilter = orderStatusFilter;
exports.orderStatusFilterByOffset = orderStatusFilterByOffset;
exports.paidFilter = paidFilter;
exports.payTypeFilter = payTypeFilter;
exports.receiptStatusFilter = receiptStatusFilter;
exports.refundStatusFilter = refundStatusFilter;
exports.retailerOrderStatusFilter = retailerOrderStatusFilter;
exports.supplierOrderLogisticsStatusFilter = supplierOrderLogisticsStatusFilter;
exports.supplierOrderLogisticsStatusFilterByOffset = supplierOrderLogisticsStatusFilterByOffset;
exports.supplierOrderStatusFilter = supplierOrderStatusFilter;
exports.supplierRefundStatusFilter = supplierRefundStatusFilter;
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

//订单过滤器

/**
 * @description 支付状态
 */
function paidFilter(status) {
  var statusMap = {
    true: '已支付',
    false: '未支付'
  };
  return statusMap[status];
}

/**
 * @description 订单状态
 * 2,已收货，待评价
 */
function orderStatusFilter(status) {
  var statusMap = {
    0: '待付款',
    1: '待发货',
    2: '部分发货',
    3: '待核销',
    4: '待收货',
    5: '已收货',
    6: '已完成',
    9: '已取消'
  };
  return statusMap[status];
}
/**
 * @description 渠道订单订单物流状态
 * 1=未发货 -> 等待卖家发货 2=已发货 -> 等待买家确认收货 3=已
 * 收货 -> 交易成功 4=已经退货 -> 交易失败 5=部分收货 -> 交易成功 6=部分发货中 8=还未创
 * 建物流订单"
 */
function supplierOrderLogisticsStatusFilter(status) {
  var statusMap = {
    '1': "未发货",
    '2': "已发货",
    '3': "已收货",
    '4': "已经退货",
    '5': "部分收货",
    '6': "部分发货中",
    '8': "还未创建物流订单"
  };
  return statusMap[status];
}

/**
 * @description 渠道退款状态
 * 2,已收货，待评价
 */
function supplierRefundStatusFilter(status) {
  var statusMap = {
    0: '待审核',
    1: '买家提交退款申请',
    2: '卖家同意⽤户退款申请',
    3: '买家提交退货物流信息',
    4: "买家关闭退款申请",
    5: "退款成功",
    6: "卖家拒绝⽤户退款申请",
    7: "等待买家确认重新邮寄的货物",
    8: "等待卖家确认退货地址",
    9: "没有申请退款",
    10: "有活动的退款",
    11: "退款结束",
    12: "卖家确认收货,等待卖家发货",
    //# 换货场景下，卖家收到买家退货物品
    14: "换货关闭,转退货退款",
    // # 买家切换售后类型：换货->退货退款
    13: "卖家已发货,等待卖家和买家确认收货",
    15: "邮费单已创建,待激活"
  };
  return statusMap[status];
}

/**
 * @description 渠道订单订单状态
 * 2,已收货，待评价
 */
function supplierOrderStatusFilter(status) {
  var statusMap = {
    '1': '待支付',
    '2': '已支付',
    '4': '已退款关闭',
    '5': '已收货',
    '6': '交易成功',
    '8': '已关闭',
    '20': '已申请退款'
  };
  return statusMap[status];
}

/**
 * @description 渠道订单订单物流状态
 * 1=未发货 -> 等待充值 2=已发货 -> 待核销 3=已
 * 收货 -> 已核销  4=已经退货 -> 交易失败
 */
function supplierOrderLogisticsStatusFilterByOffset(status) {
  var statusMap = {
    '1': "等待充值",
    '2': "待核销",
    '3': "已核销",
    '4': "已经退货"
  };
  return statusMap[status];
}

/**
 * @description 订单状态
 * 2,已收货，待评价
 */
function orderStatusFilterByOffset(status) {
  var statusMap = {
    0: '待支付',
    1: '未充值',
    2: '未充值',
    3: '待核销',
    4: '待核销',
    5: '待核销',
    6: '已核销',
    9: '已取消',
    10: '推送渠道成功',
    11: '推送渠道失败',
    12: "推送中"
  };
  return statusMap[status];
}
function receiptStatusFilter(status) {
  var statusMap = {
    '0': '待开票',
    '1': '已开票',
    '3': '拒绝开票'
  };
  return statusMap[status];
}

/**
 * @description 销售端 - 订单状态
 * 2,已收货，待评价
 *
 * 订单状态（0：待支付，1：待发货,2：部分发货， 3：待核销，4：待收货,5：已收货,6：已完成，9：已取消11 处理失败 10处理成功12t处理中13待处理）
 */
function retailerOrderStatusFilter(status) {
  var statusMap = {
    0: '待付款',
    1: '待发货',
    2: '部分发货',
    3: '待核销',
    4: '待收货',
    5: '已收货',
    6: '交易成功',
    9: '已取消',
    10: '渠道交易中',
    11: '平台处理失败',
    12: '平台处理中',
    13: '平台待处理'
  };
  return statusMap[status];
}

/**
 * @description 订单中的退款状态
 *
 */
function orderRefundStatusFilter(status) {
  var statusMap = {
    0: '未退款',
    1: '申请退款中',
    2: '部分退款',
    3: '已退款'
  };
  return statusMap[status];
}

/**
 * @description 退款状态
 * 2,已收货，待评价
 */
function refundStatusFilter(status) {
  var statusMap = {
    0: '待审核',
    1: '拒绝退款',
    2: '退款中',
    3: '已退款'
  };
  return statusMap[status];
}

/**
 * @description 支付方式
 */
function payTypeFilter(status) {
  var statusMap = {
    weixin: '微信',
    alipay: '支付宝',
    yue: '余额'
  };
  return statusMap[status];
}
/**
 * @description 滴滴订单状态
 */
function didiOrderStatusFilter(status) {
  var statusMap = {
    1: '新单',
    2: '已取消',
    3: '已超时',
    4: '已接单',
    5: '已到达',
    6: '开始服务',
    7: '结束服务',
    8: '计费完成'
  };
  return statusMap[status];
}

/**
 * @description 滴滴支付状态
 */
function didiPayStatusFilter(status) {
  var statusMap = {
    1: '待支付',
    2: '已支付',
    3: '支付关闭'
  };
  return statusMap[status];
}